import { render, staticRenderFns } from "./SnowDetail.vue?vue&type=template&id=72018277&scoped=true&"
import script from "./SnowDetail.vue?vue&type=script&lang=js&"
export * from "./SnowDetail.vue?vue&type=script&lang=js&"
import style0 from "./SnowDetail.vue?vue&type=style&index=0&id=72018277&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72018277",
  null
  
)

export default component.exports